import { ArcGauge } from "@iliotech/widgets";
import s from "./RiskGaugeMonthlyWidget.module.scss";
import {
  sendRequest,
  useReportBespoke,
  useRiskWire,
  VOLATILITY_INFO,
} from "@iliotech/data-wire";
import { useParams } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { ReportWidgetProps } from "../../ReportWidgetProps";

export const RiskGaugeMonthlyWidget = observer((props: ReportWidgetProps) => {
  const { portfolioId } = useParams<{ portfolioId: string }>();
  const store = useReportBespoke();
  const periodString = props.periodContext.periodString;
  const riskWire = useRiskWire({
    portfolioId: portfolioId!,
    sendRequest: sendRequest,
    frequency: "Monthly",
    overridePeriod: props.periodContext.periodForRequest,
  });
  const { volatilityResponse } = riskWire.serverData;
  const loadingStats =
    volatilityResponse === undefined ? true : !volatilityResponse.data;

  const volatilityNumber =
    volatilityResponse?.data?.data?.portfolio?.volatility;

  const generating = store.generating;
  const volatilityInfo = VOLATILITY_INFO(
    volatilityNumber!,
    (v: string) => v,
    loadingStats
  );
  const width = props.width
    ? props.isHalfHeight && !props.isHalfWidth
      ? props.width * 0.4
      : props.width * 0.7
    : 200;
  return (
    <div>
      <div className={s.row}>
        <div className={s.arcWrapper}>
          <h4 className={"element-title"}>{"Your Portfolio Risk (Monthly)"}</h4>
          <p
            style={{ marginTop: -15, marginBottom: 10 }}
            className={"period-string"}
          >
            {periodString}
          </p>
          <div>
            <ArcGauge
              isPdfExport={generating}
              width={width}
              loading={loadingStats}
              values={{
                min: 0,
                max: 24,
                actual: volatilityNumber ?? 0,
              }}
              title={"Portfolio Risk"}
              valueLabel={volatilityInfo.label}
              valueLabelColor={volatilityInfo.color}
              color={volatilityInfo.color}
            />
          </div>
        </div>
      </div>
    </div>
  );
});
